import React, {Component} from 'react'
import {Button, Modal, Input, Header, Dropdown, Form, Checkbox} from 'semantic-ui-react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {notesFrequency} from "../../utils/constants";
import ReactS3Uploader from "react-s3-uploader";
import config from "../../config";
import { authHeaders } from "../../constants";
import Loading from "../Loading";
import ShowFilesModal from "../ManageHelp/ShowFilesModal";
import moment from "moment/moment";
import {notesType} from "../../constants";
import {connect} from "react-redux";
import {
    getFinancialNoteCategories, getPracticesList
} from '../../redux/modules/schedule';
import {getSageAccounts} from "../../redux/modules/sageAccounts";
import {buildPracticeLists, getUniqueArrObj} from "../../utils/commonutils";

const missingProviderFieldAlert = (fieldLabel, possibleValues) => {
    alert(
        `Missing ${fieldLabel} for the selected provider. This must be filled in on ` +
        `the provider's profile before this note can be saved (not in this form). ` +
        `Possible values: ${possibleValues.join(', ')}.`
    );
};

class AddNotesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progressCountVar : 0,
            showFiles: false,
            errors: {},
            notesForm: {
                id: 0,
                notesType: 'Financial',
                title: null,
                desc: null,
                financialNotes: 0,
                practice: null,
                date: moment().startOf("day").valueOf(),
                dentists: [],
                dentistsId: [],
                frequency: "",
                category: "",
                sageAccount: null,
                isTaxable: false,
                bcare: 0,
                practiceId: 0,
                receipts : [],
                documentation : '',
            },
            drArray: [],
            drList: [],
            notesDrList: [],
            categories:[],
            dentistType: null,
            practices: [ { key: 'all', value: 'all', text: 'All' } ],
            locationList: [],
            practiceArray: [],
            showConfirmDelete: false,
            payType : false,
            ukg : false,
            sageAccounts: [],
        };
    }

    validationRules = {
        notesType: 'Notes Type is required',
        title: 'Title is required',
        desc: 'Description is required',
        practice: 'Practice is required',
        dentists: 'At least one dentist must be selected',
        category: 'Category is required',
        frequency: 'Frequency is required',
        sageAccount: 'Sage Account is required',
    };

    componentDidMount() {
        const {user, notesForm} = this.props;

        this.getFinancialNoteCategories();
        this.getPracticesData(0);
        this.getSageAccounts();

        if (notesForm && notesForm.id > 0) {
            this.setState({
                notesForm: {
                    ...notesForm,
                    date: moment(notesForm.date).startOf("day").valueOf()
                }
            });
        }

        let drArray = [];
        if (user && user.scheduleDoctors && Object.keys(user.scheduleDoctors).length) {
            let notesDrList = [];
            Object.keys(user.scheduleDoctors).forEach(id => {
                const drItem = user.scheduleDoctors[id];
                drArray.push(drItem);
                const type = drItem['dentistType'] === 'Hygienists' ? 'RDH' : '';
                notesDrList.push({
                    key: id && id.trim(),
                    value: id && id.trim(),
                    text: `Dr. ${drItem['firstName']} ${drItem['lastName']} ${type}`,
                    payType : drItem && drItem.payType,
                });
            });
            notesDrList = getUniqueArrObj(notesDrList, 'value');
            this.setState({
                drList: notesDrList,
                drArray: drArray,
                notesDrList : [...notesDrList ]
            }, () => {
                this.setPayType();
            });

        }
    }

    getSageAccounts = () => {
        const {dispatch} = this.props;
        dispatch(getSageAccounts()).then(accounts => {
            accounts = accounts ? accounts.map(acc => {
                return {
                    value: '' + acc.accountNumber,
                    text: `${acc.accountNumber} - ${acc.accountDescription}`,
                    ukg : acc.ukg,
                    taxable : acc.taxable,
                }
            }) : []
            this.setState({sageAccounts: accounts},()=> {
                this.setUKG()
            })
        })
    }

    getFinancialNoteCategories = () => {
        const { dispatch } = this.props;
        dispatch(getFinancialNoteCategories()).then(categories => {
            categories = categories ? categories.map(acc => {
                return {value: acc.name, text: acc.name}
            }) : []
            let categoryList = categories.filter((item) => item.value !== "All")
            // Snap an existing note's category to the canonical option when it
            // only differs by case (e.g. legacy "Recovery of prior Writeoffs"
            // vs "Recovery of prior writeoffs"), so the controlled dropdown
            // preselects it and it saves with the correct value.
            this.setState(prev => {
                const current = prev.notesForm && prev.notesForm.category;
                let notesForm = prev.notesForm;
                if (current && !categoryList.some(c => c.value === current)) {
                    const match = categoryList.find(
                        c => c.value.toLowerCase() === String(current).toLowerCase()
                    );
                    if (match) {
                        notesForm = { ...prev.notesForm, category: match.value };
                    }
                }
                return { categories: categoryList, notesForm };
            })
        })
    }

    deleteScheHandleConfirm = () => {
        this.setState({ showConfirmDelete: true });
    }

    getPracticesData = (doctorSelected) => {
        const { dispatch } = this.props;
        const { practiceSelected } = this.state;
        this.setState({ loading: true });

        if (
            doctorSelected == 0 ||
            (doctorSelected.length < 2 && practiceSelected.length === 0)
        ) {
            dispatch(getPracticesList(doctorSelected)).then((data) => {
                const {
                    practiceArray,
                    practiceList,
                    practices,
                    locationList,
                } = buildPracticeLists(data);

                this.setState({
                    loading: false,
                    practiceArray,
                    practiceList,
                    practices,
                    locationList,
                });
            });
        }
    };

    onChangeNotesDate = (date, name) => {
        let {notesForm} = this.state;
        notesForm[name] = date;
        this.setState({
            notesForm
        });
    };

    onChangeNotes = (e, data, name) => {
        let {notesForm, drArray, practices, locationList, practiceArray} = this.state;
        const { value, taxable } = data;

        notesForm[name] = value;
        if (notesForm.dentists[0] === 'all' && notesForm.dentists.length > 1) {
            notesForm.dentists.splice(0, 1);
        } else if (notesForm.dentists.length > 1 && notesForm.dentists[notesForm.dentists.length - 1] === 'all') {
            notesForm.dentists.splice(0, notesForm.dentists.length - 1);
        } else if (notesForm.dentists.length === 0) {
            // notesForm.dentists.push("all");
        }
        if(name === 'practice'){
            notesForm.practiceId = practices.find(practice => practice.value === value).key;
        }
        if(name === 'dentists') {
            const dentist = drArray.find(dr => dr.id === parseInt(value));
            if(dentist && dentist.dentistType === 'Ortho') {
                const orthoPractices = practiceArray.filter(practice => practice.orthoLocation !== null && practice.orthoLocation !== '');
                const orthoPracticeNames = orthoPractices.map(x=> x.practice);
                const practices = locationList.filter(practice => orthoPracticeNames.includes(practice.value));
                this.setState({practices, dentistType: 'Ortho'});

            } else{
                const cdpPractices = practiceArray.filter(practice => practice.orthoLocation === null || practice.orthoLocation === '');
                const cdpPracticeNames = cdpPractices.map(x=> x.practice);
                const practices = locationList.filter(practice => cdpPracticeNames.includes(practice.value));
                this.setState({practices, dentistType: 'CDP'});
            }
        }
        if(name === 'sageAccount'){
            notesForm.isTaxable = taxable;
        }
        this.setState({ notesForm });
    };

    onChangeNotesInput = (e) => {
        let {notesForm} = this.state;
        notesForm[e.target.name] = e.target.validity.valid ? e.target.value : notesForm[e.target.name];
        this.setState({ notesForm });
    };

    onChangeNotesRecipts = (receipts) => {
        let {notesForm} = this.state;
        notesForm.receipts = receipts
        this.setState({ notesForm });
    };

    setPayType = () => {
        const {notesForm, drList} = this.state;
        if (notesForm.notesType === "Financial") {
            const selectedOption = drList.find(opt => opt.value == notesForm.dentistId);
            this.setState({payType : selectedOption?.payType})
        }
    }

    setUKG = () => {
        const {notesForm, sageAccounts} = this.state;
        if (notesForm.notesType === "Financial") {
            const selectedOption = sageAccounts.find(opt => opt.value == notesForm.sageAccount);
            this.setState({ukg : selectedOption?.ukg})
        }
    }

    handleSubmit = () => {
        const { notesForm, notesDrList, payType } = this.state;
        const { notesType, receipts, isTaxable, category } = notesForm;
        const newErrors = {};
        if (!notesType) {
            newErrors["notesType"] = this.validationRules.notesType
        }

        if(notesType === "Financial" && !payType) {
            missingProviderFieldAlert('Pay Type', ['W2', '1099']);
            return;
        }

        const isUkgHygCategory = category && category.includes("UKG HYG");

        if( (notesType === "Financial" && !receipts || receipts.length < 1)  && !isTaxable && !isUkgHygCategory) {
            alert("Missing Receipt File for non-taxable note. Please upload a Receipt File.");
            return;
        }

        if (notesType === 'Financial') {
            Object.entries(this.validationRules).forEach(([fieldName, errorMessage]) => {
                if (!notesForm[fieldName] || (typeof notesForm[fieldName] === "object"
                    && Object.entries(notesForm[fieldName]).length === 0)) {
                    newErrors[fieldName] = errorMessage;
                }
            });
        }
        // Custom validation: Only one of Financial Amount or B.Care can be non-zero
        if (notesForm.notesType === 'Financial') {
            const bcareVal = parseFloat(notesForm.bcare || 0);
            const finVal = parseFloat(notesForm.financialNotes || 0);
            const isBcareZero = bcareVal === 0 || isNaN(bcareVal);
            const isFinZero = finVal === 0 || isNaN(finVal);

            if ((isBcareZero && isFinZero) || (!isBcareZero && !isFinZero)) {
                newErrors["bcare"] = "Either Financial Amount or B.Care must be filled (not both or neither)";
                newErrors["financialNotes"] = "Either Financial Amount or B.Care must be filled (not both or neither)";
            }
        }

        if (Object.keys(newErrors).length === 0) {
            // Form is valid, proceed with submission
            let dentists = [];
            let dentistsId = [];
            if (notesForm.notesType !== 'Public') {
                if (notesForm.notesType !== 'Private') {
                    dentists = notesForm.dentists;
                    dentistsId = notesDrList.filter(dr => {
                        return notesForm.dentists == dr.value;
                    });
                } else {
                    if (notesForm.dentists[0] === 'all') {
                        dentists = notesDrList.map(dr => {
                            if (dr.value !== 'all') {
                                dentistsId.push(dr);
                                return dr.value;
                            }
                        })
                    } else {
                        dentists = notesForm.dentists;
                        dentistsId = notesDrList.filter(dr => {
                            return notesForm.dentists.indexOf(dr.value) > -1;
                        });
                    }
                }
            }
            let notes = {
                id: notesForm.id,
                notesType: notesForm.notesType,
                dentist: dentists,
                dentistId: dentistsId,
                practice: notesForm.practice,
                title: notesForm.title,
                desc: notesForm.desc,
                date: [moment(notesForm.date).utc().valueOf()],
                dateString : [moment(notesForm.date).format("MM-DD-YYYY")],
                financialNotes: notesForm.financialNotes,
                category: notesForm.category,
                frequency: notesForm.frequency,
                sageAccount: notesForm.sageAccount,
                bcare: notesForm.bcare,
                isTaxable: !!notesForm.isTaxable,
                practiceId: notesForm.practiceId,
                receipts: notesForm.receipts,
                documentation : notesForm.documentation
            };

            this.props.onClickPublishNotes(notes);
        } else {
            // Form is invalid, update errors state
            this.setState({ errors: newErrors });
        }
    };

    onUploadStart = (file, next) => {
        const { progressCountVar } = this.state;
        this.setState({
                progressCountVar : progressCountVar + 1
            },()=> {
                next(file);
            }
        );

    };

    onUploadError = (e) => {
        const { progressCountVar } = this.state;
        console.log("onUploadError", e);
        alert("Upload file error.");
        this.setState({
            progressCountVar : progressCountVar-1
        })
    };

    showFiles = () => {
        this.setState({showFiles: true});
    };

    closeFilesModal = () => {
        this.setState({showFiles: false});
    };

    onFinish = async (e) => {
        const { progressCountVar, notesForm } = this.state;
        if (!notesForm.receipts) {
            notesForm.receipts = [];
        }
        notesForm.receipts.push(e.signedUrl.split("?").shift());
        this.onChangeNotesRecipts(notesForm.receipts)
        this.setState({
            progressCountVar: progressCountVar - 1,
        });
    };

    deleteFiles = (keys) => {
        const { notesForm} = this.state;
        keys = keys.sort(function (a, b) {
            return b - a;
        });
        if (keys.length) {
            keys.forEach((key) => {
                if (notesForm.receipts[parseInt(key)]) {
                    notesForm.receipts.splice(parseInt(key), 1);
                }
            });
        }
        this.onChangeNotesRecipts(notesForm.receipts)
    };

    render() {
        const {isLoad} = this.props;
        const { errors, payType, progressCountVar, showFiles, notesForm, notesDrList, practices,
            drList, categories, dentistType, showConfirmDelete, sageAccounts, ukg } = this.state;
        const sageAccountsOptions = sageAccounts.map((opt, index) => ({
            key: `${opt.value}_${index}`, // unique per entry
            text: opt.text,
            value: opt.value,
            ukg : opt.ukg,
            taxable : opt.taxable,
        }));
        return (
            <>
                {isLoad && <Loading/>}
                {showFiles && (
                    <ShowFilesModal
                        closeModal={this.closeFilesModal}
                        files={notesForm.receipts}
                        deleteFiles={this.deleteFiles}
                    />
                )}
                <Modal
                    open={true}
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                    onClose={this.props.hideNotesModal}
                    centered={false}
                    size='large'
                    closeIcon
                >
                    <Header content='Add Notes'/>
                    <Modal.Content>
                        <Form className="">
                            <Form.Group widths={"equal"}>
                                <Form.Field>
                                    <label>Notes Type </label>
                                    <Dropdown
                                        error={errors.notesType}
                                        search
                                        fluid
                                        required
                                        name='notesType'
                                        selection
                                        onChange={(e, a) => this.onChangeNotes(e, a, 'notesType')}
                                        placeholder='Select Notes Type'
                                        value={notesForm.notesType || ''}
                                        options={notesType}/>
                                    {errors.notesType && <span style={{color: 'red'}}>{errors.notesType}</span>}
                                </Form.Field>
                                <Form.Field error={errors.title}>
                                    <label>Notes Title </label>
                                    <Input
                                        fluid
                                        value={notesForm.title || ""}
                                        required
                                        type='text'
                                        maxLength="15"
                                        name='title'
                                        onChange={(e) => this.onChangeNotesInput(e)}
                                    />
                                    {errors.title && <span style={{color: 'red'}}>{errors.title}</span>}
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths={"equal"}>
                                <Form.Field error={errors.desc}>
                                    <label>Notes Description </label>
                                    <Input
                                        fluid
                                        required
                                        name='desc'
                                        type='text'
                                        onChange={(e) => this.onChangeNotesInput(e)}
                                        value={notesForm.desc || ""}/>
                                    {errors.desc && <span style={{color: 'red'}}>{errors.desc}</span>}
                                </Form.Field>
                                <Form.Field>
                                    <label>Select Practice </label>
                                    <Dropdown
                                        error={errors.practice}
                                        search
                                        fluid
                                        required
                                        name='practice'
                                        selection
                                        onChange={(e, a) => this.onChangeNotes(e, a, 'practice')}
                                        placeholder='Select Practice'
                                        value={notesForm.practice || ''}
                                        options={practices}/>
                                    {errors.practice && <span style={{color: 'red'}}>{errors.practice}</span>}
                                </Form.Field>
                            </Form.Group>
                            {notesForm.notesType === 'Private' &&
                                <Form.Group widths={"equal"}>
                                    <Form.Field>
                                        <label>Select Dentists </label>
                                        <Dropdown
                                            search
                                            fluid
                                            required
                                            name='dentists'
                                            multiple selection
                                            value={notesForm.dentists || []}
                                            onChange={(e, a) => this.onChangeNotes(e, a, 'dentists')}
                                            placeholder='Select Dentist'
                                            options={notesDrList}/>
                                    </Form.Field>
                                </Form.Group>
                            }
                            {notesForm.notesType === 'Financial' &&
                                <React.Fragment>
                                    <Form.Group widths={"equal"}>
                                        <Form.Field>
                                            <label>Select Category </label>
                                            <Dropdown
                                                error={errors.category}
                                                search fluid required selection
                                                name='category'
                                                value={notesForm.category || ''}
                                                onChange={(e, a) => this.onChangeNotes(e, a, 'category')}
                                                placeholder='Select Category'
                                                options={categories}/>
                                            {errors.category && <span style={{color: 'red'}}>{errors.category}</span>}
                                        </Form.Field>

                                        <Form.Field error={errors.dentists}>
                                            <label>Select Provider <b>{payType && `(${payType})`}</b></label>
                                            <Dropdown
                                                search
                                                fluid
                                                required
                                                name='dentists'
                                                selection
                                                value={notesForm.dentists}
                                                onChange={(e, a) => {
                                                    const selectedOption = a.options.find(opt => opt.value == a.value);
                                                    this.setState({payType : selectedOption?.payType})
                                                    this.onChangeNotes(e, a, 'dentists')}
                                                }
                                                placeholder='Select Dentist'
                                                options={drList}/>
                                            {errors.dentists && <span style={{color: 'red'}}>{errors.dentists}</span>}
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths={"equal"}>
                                        <Form.Field error={errors.frequency}>
                                            <label>Select Frequency </label>
                                            <Dropdown
                                                search fluid required selection
                                                name='frequency'
                                                value={notesForm.frequency}
                                                onChange={(e, a) => this.onChangeNotes(e, a, 'frequency')}
                                                placeholder='Select Frequency'
                                                options={notesFrequency}/>
                                            {errors.frequency && <span style={{color: 'red'}}>{errors.frequency}</span>}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Select Account </label>
                                            <Dropdown
                                                error={errors.sageAccount}
                                                search fluid required selection
                                                name='sageAccount'
                                                value={notesForm.sageAccount}
                                                onChange={(e, a) => {
                                                    const selectedOption = a.options.find(opt => opt.value == a.value);
                                                    this.setState({ukg : selectedOption?.ukg})
                                                    this.onChangeNotes(e, {
                                                        ...a,
                                                        taxable : selectedOption?.taxable
                                                    }, 'sageAccount')}
                                                }
                                                placeholder='Select Account'
                                                options={sageAccountsOptions}/>
                                            {errors.sageAccount && <span style={{color: 'red'}}>{errors.sageAccount}</span>}
                                        </Form.Field>
                                    </Form.Group>

                                    <Form.Group widths={"equal"}>
                                        {dentistType !== 'Ortho' && <Form.Field>
                                            <label>B.Care Amount </label>
                                            <Input
                                                fluid
                                                name='bcare'
                                                type='number'
                                                pattern="^-?\d*[.,]?\d{0,2}$"
                                                onChange={(e) => this.onChangeNotesInput(e)}
                                                value={notesForm.bcare || ""}/>
                                            {errors.bcare && <span style={{color: 'red'}}>{errors.bcare}</span>}
                                        </Form.Field>}
                                        <Form.Field>
                                            <label>Financial Amount </label>
                                            <Input
                                                fluid
                                                name='financialNotes'
                                                type='text'
                                                pattern="^-?\d*[.,]?\d{0,2}$"
                                                onChange={(e) => this.onChangeNotesInput(e)}
                                                value={notesForm.financialNotes || ""}/>
                                            {errors.financialNotes && <span style={{color: 'red'}}>{errors.financialNotes}</span>}
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <label>Documentation </label>
                                            <Input
                                                fluid
                                                name='documentation'
                                                type='text'
                                                onChange={(e) => this.onChangeNotesInput(e)}
                                                value={notesForm.documentation || ""}/>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths={"equal"}>
                                        <Form.Field>
                                            <Checkbox
                                                label="Taxable"
                                                disabled={true}
                                                value={notesForm.isTaxable ? 1: 0}
                                                checked={notesForm.isTaxable ? 1 : 0}
                                            />
                                            <span className={'ml15'}><b>{ukg}</b></span>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <label>Please select a date </label>
                                            <DatePicker popperPlacement="top-end" fluid required className='ui input' dateFormat="yyyy-MM-dd" selected={notesForm.date} onChange ={(e)=>this.onChangeNotesDate(e, 'date')}/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>
                                                Upload File (Upload Only pdf/image)
                                                {notesForm.receipts && notesForm.receipts.length ? (
                                                    <p>
                                                        <br/>
                                                        Total Files: {notesForm.receipts.length}{" "}
                                                        <span href="#" onClick={this.showFiles}>
                            (Click to Show)
                          </span>
                                                    </p>
                                                ) : (
                                                    ""
                                                )}
                                            </label>
                                            <br/>
                                            <ReactS3Uploader
                                                multiple
                                                signingUrl={`${config.apiHost}/scheduler/upload/receipts`}
                                                signingUrlHeaders={authHeaders()}
                                                signingUrlMethod="GET"
                                                signingUrlQueryParams={{bucket: "cdp-uss-uploads/cdp-notes"}}
                                                className="form-group"
                                                accept={".jpg, .jpeg, .png, .pdf"}
                                                uploadRequestHeaders={{
                                                    "x-amz-acl": "public-read",
                                                }}
                                                preprocess={(file, next) =>
                                                    this.onUploadStart(file, next)
                                                }
                                                onError={this.onUploadError}
                                                onFinish={(res) => this.onFinish(res)}
                                            />
                                            {progressCountVar > 0 ? <Loading/> : ""}
                                        </Form.Field>
                                    </Form.Group>
                                </React.Fragment>

                            }

                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        {notesForm.id > 0 &&   <Button negative onClick={this.deleteScheHandleConfirm} floated='left'>
                            Delete
                        </Button> }
                        <Button secondary onClick={this.props.hideNotesModal}>
                            Cancel
                        </Button>
                        <Button primary onClick={this.handleSubmit}>
                            Save and Publish
                        </Button>
                    </Modal.Actions>
                    <Modal
                        open={showConfirmDelete}
                        size='mini'>
                        <Modal.Header>Delete Notes</Modal.Header>
                        <Modal.Content>
                            <Form className="formStyle mt10">
                                <div className="row">
                                    <div className="col-12">
                                        <label>Warning, this cannot be undone!</label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        Are you sure you want to delete?
                                    </div>
                                </div>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button secondary onClick={this.props.hideNotesModal}>Cancel</Button>
                            <Button negative onClick={() => this.props.deleteNotesHandle(notesForm.id)}>Delete</Button>
                        </Modal.Actions>
                    </Modal>
                </Modal>
            </>

        );
    }
}
export default connect(state => ({
    user: state.get('auth').get('user'),
    isLoad: state.get('schedule').get('isLoad')
}))(AddNotesModal);